import * as tslib_1 from "tslib";
import { Base } from '../base-component';
import './file-list-filter-none.component.scss';
var FileListFilterNone = /** @class */ (function (_super) {
    tslib_1.__extends(FileListFilterNone, _super);
    function FileListFilterNone(element) {
        return _super.call(this, element) || this;
    }
    FileListFilterNone.prototype.init = function () {
        this.detailBlocks = Array.from(this.element.querySelectorAll('.file-list-filter-none__detail'));
        this.checkEmptyContainers();
    };
    FileListFilterNone.prototype.bindEvents = function () { };
    FileListFilterNone.prototype.checkEmptyContainers = function () {
        this.detailBlocks.map(function (item, index) {
            var text = item.textContent;
            var content = text.trim().replace(/ /g, '');
            if (content === '') {
                item.classList.add('file-list-filter-none__detail--no-border');
            }
        });
    };
    return FileListFilterNone;
}(Base));
export { FileListFilterNone };



//////////////////
// WEBPACK FOOTER
// ./components/file-list-filter-none/file-list-filter-none.component.ts
// module id = 284
// module chunks = 0